import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import DropdownOption from 'components/Common/DropdownOption';
import LabelWrapper from 'components/Common/LabelWrapper';
import { useRole } from 'components/Hooks/UserHooks';
import { AI_MODEL_BOOSTING_NEWS_WEATHER_OPTIONS, SYSTEM_CONFIG_KEY } from 'helpers/constans';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CardBody, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from "reactstrap";
import { getConfiguration, putConfiguration } from "../../../../store/thunks";

interface ModalConfigGenerateProps {
    isOpen: boolean;
    onClose: () => void;
}

const ModalConfigGenerate = ({ isOpen = false, onClose = () => { } }: ModalConfigGenerateProps) => {
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();

    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [condition, setCondition] = useState<{
        generate_head_prompt: string,
        generate_tail_prompt: string,
        ai_model: string
        blocked_places: string,
    } | null>(null);

    const AI_MODEL_NEWS_TRAVEL_OPTIONS_LANG: any = AI_MODEL_BOOSTING_NEWS_WEATHER_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

    const handleSave = async () => {
        try {
            if (isSaving) {
                return;
            }
            setIsSaving((_prev) => true);
            const _config = {
                configs: [
                    {
                        key: SYSTEM_CONFIG_KEY.WEATHER_WARNING_NEWS_GENERATE_HEAD_PROMPT,
                        value: String(condition?.generate_head_prompt ?? ''),
                        is_active: 1,
                    },
                    {
                        key: SYSTEM_CONFIG_KEY.WEATHER_WARNING_NEWS_GENERATE_TAIL_PROMPT,
                        value: String(condition?.generate_tail_prompt ?? ''),
                        is_active: 1,
                    },
                    {
                        key: SYSTEM_CONFIG_KEY.WEATHER_WARNING_NEWS_GENERATE_AI_MODEL,
                        value: String(condition?.ai_model ?? ''),
                        is_active: 1,
                    },
                    // {
                    //     key: SYSTEM_CONFIG_KEY.WEATHER_NEWS_BLOCKED_PLACES,
                    //     value: String(condition?.blocked_places ?? ''),
                    //     is_active: 1,
                    // },
                ]
            };
            const response: any = await putConfiguration(_config);
            setIsSaving((_prev) => false);
            if (response?.code === 200) {
                toast(t("The process has been completed."), CONFIG_OPTION_TOAST_NORMAL);
                onClose?.();
            } else {
                toast(response?.message || response, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsSaving((_prev) => false);
            toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    }


    const handleGetConfig = async () => {
        try {
            const response: any = await getConfiguration();
            if (response?.code === 200) {
                const _configs = response?.data?.list || [];
                const data = {
                    generate_head_prompt: _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.WEATHER_WARNING_NEWS_GENERATE_HEAD_PROMPT)?.value || '',
                    generate_tail_prompt: _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.WEATHER_WARNING_NEWS_GENERATE_TAIL_PROMPT)?.value || '',
                    ai_model: _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.WEATHER_WARNING_NEWS_GENERATE_AI_MODEL)?.value || '',
                    // blocked_places: _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.WEATHER_NEWS_BLOCKED_PLACES)?.value || '',
                }
                setCondition((_prev: any) => ({ ..._prev, ...data }));
            }
        } catch (error: any) {
            toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    }

    useEffect(() => {
        if (isOpen) {
            handleGetConfig();
        }
    }, [isOpen]);

    return (
        <React.Fragment>
            <Modal
                isOpen={isOpen}
                centered={true}
                size="lg"
                scrollable={false}
            >
                <ModalHeader toggle={() => onClose?.()}>
                    <>{t("Config Generate")}</>
                </ModalHeader>
                <ModalBody className="pt-2">
                    <Row>
                        {isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS_TRAVEL, userPermissions) && (
                            <Col lg={12}>
                                <CardBody className="pt-3">
                                    <Row>
                                        <Col sm={12} md={6} lg={4} xl={4} xxl={4} className='mt-0 mb-3'>
                                            <LabelWrapper label={t('AI Model')} isShow={true} colorText="var(--vz-primary)">
                                                <DropdownOption
                                                    name="ai_model"
                                                    dataList={AI_MODEL_NEWS_TRAVEL_OPTIONS_LANG || []}
                                                    placeholder={`${t("AI Model")}...`}
                                                    className={`dropdown-status-rounded z-hight mb-3 mb-lg-2 mb-xxl-1`}
                                                    classNamePrefix="name-prefix"
                                                    initialValue={AI_MODEL_NEWS_TRAVEL_OPTIONS_LANG?.find((item: any) => item?.value === condition?.ai_model) || AI_MODEL_NEWS_TRAVEL_OPTIONS_LANG[0]}
                                                    onChangeSelect={(e: any) => {
                                                        setCondition((_prev: any) => ({ ..._prev, ai_model: e?.value }))
                                                    }}
                                                />
                                            </LabelWrapper>
                                        </Col>
                                        <Col sm={12} className='mt-1 mb-2'>
                                            <LabelWrapper label={t('Head Prompt')} isShow={true} colorText="var(--vz-primary)">
                                                <Input
                                                    name="text"
                                                    type="textarea"
                                                    className="form-control mb-3 mb-lg-2 mb-xxl-1"
                                                    placeholder=""
                                                    style={{ height: '200px' }}
                                                    value={condition?.generate_head_prompt}
                                                    onChange={(event: any) => {
                                                        const input = event.target.value;
                                                        setCondition((_prev: any) => ({ ..._prev, generate_head_prompt: input }))
                                                    }}
                                                    autoComplete="off"
                                                />
                                                {/* <div className="w-100 mb-1 mb-xl-0 fs-12 text-muted pt-0">
                                                    {t(`{{keywords}} will replace dynamically`, { keywords: `{chat_history_block}, {search_query}, {current_date}, {weather_info}, {places_data_json}` })}
                                                </div> */}
                                            </LabelWrapper>
                                        </Col>
                                        <Col sm={12} className='mt-3 mb-2'>
                                            <LabelWrapper label={t('Tail Prompt')} isShow={true} colorText="var(--vz-primary)">
                                                <Input
                                                    name="text"
                                                    type="textarea"
                                                    className="form-control mb-3 mb-lg-2 mb-xxl-1"
                                                    placeholder=""
                                                    style={{ height: '200px' }}
                                                    value={condition?.generate_tail_prompt}
                                                    onChange={(event: any) => {
                                                        const input = event.target.value;
                                                        setCondition((_prev: any) => ({ ..._prev, generate_tail_prompt: input }))
                                                    }}
                                                    autoComplete="off"
                                                />
                                                <div className="w-100 mb-1 mb-xl-0 fs-12 text-muted pt-0">
                                                    {t(`{{keywords}} will replace dynamically`, { keywords: `{region}, {warning_type}, {warning_level}, {warning_time}, {warning_content}, {current_weather}` })}
                                                </div>
                                            </LabelWrapper>
                                        </Col>
                                    </Row>
                                    {/* <Col sm={12} md={12} xl={12} className='mt-4'>
                                        <LabelWrapper label={t('Blocked Places')} isShow={true} colorText="var(--vz-primary)">
                                            <Input
                                                className="form-control"
                                                id="blocked_places"
                                                name="blocked_places"
                                                type="textarea"
                                                autoComplete='off'
                                                rows={10}
                                                value={condition?.blocked_places || ''}
                                                placeholder={t('Blocked Places')}
                                                onChange={(e: any) => {
                                                    setCondition((_prev: any) => ({ ..._prev, blocked_places: e?.target?.value || '' }));
                                                }}
                                            />
                                        </LabelWrapper>
                                    </Col> */}
                                </CardBody>
                            </Col>
                        )}
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <div className="d-flex justify-content-center align-item-center"></div>
                    <button
                        className="btn btn-primary"
                        type="button"
                        onClick={handleSave}
                        style={{ width: '120px' }}
                        disabled={isSaving}
                    >
                        {isSaving ? <Spinner size="sm" className="me-2" ></Spinner> : <></>}
                        {t("Button Save")}
                    </button>
                </ModalFooter>
            </Modal>
        </React.Fragment >
    );
};

export default ModalConfigGenerate;